import { render, staticRenderFns } from "./product-wrap.modal.vue?vue&type=template&id=3319f0f1&scoped=true&"
import script from "./product-wrap.modal.vue?vue&type=script&lang=js&"
export * from "./product-wrap.modal.vue?vue&type=script&lang=js&"
import style0 from "./product-wrap.modal.vue?vue&type=style&index=0&id=3319f0f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3319f0f1",
  null
  
)

export default component.exports